import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Typography } from '@mui/material';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);



const ChartPie = (props) => {
  const { data, onClick } = props

  const handleChartClick = (evt, elements) => {
    if (elements.length > 0) {
      const clickedIndex = elements[0].index;
      const clickedLabel = data.labels[clickedIndex];
      onClick && onClick(clickedLabel)
    }
  };

  return (
    <>
      <div className="title_chart">
        <Typography className="content-text" variant="h6" style={{ fontSize: '1.15rem' }}>
          {data.title}
        </Typography>
        <Typography className="content-text" style={{ fontSize: '0.9 rem' }}>
          {data.subTitle}
        </Typography>
      </div>
      <div className="body_chart" style={{ display: 'flex', justifyContent: 'center' }}>
        {
          data?.labels &&
          <Pie data={data} options={{
            plugins: {
              legend: {
                display: true,
                position: "bottom",
              },
              title: {
                display: true,
                text: data.unit,
                position: "left"
              },
              tooltip: {
                enabled: true,
                usePointStyle: true,
                callbacks: {
                  title: (datas) => {
                    return datas.label /* datas[0].dataset.label */
                  },
                  label: (datas) => {
                    let value = (datas.raw % 1 !== 0) ? Number(datas.raw).toFixed(2) : datas.raw;
                    return `Total: ${value}`
                  }
                },
              }
            },
            onClick: handleChartClick
          }} />
        }
      </div>
    </>
  )
}

export default ChartPie